<template>
<div :data-testid="TEST_ID.GESTION_NOTICIAS.CARD_ITEM">
    <el-card>
        <div class="cardBody">
          <el-row>
            <el-col :span="1">
            <div :data-testid="TEST_ID.GESTION_NOTICIAS.CARD_EXPAND_BUTTON" :class="opened ? 'triangleDown' : 'triangleRight'" v-on:click="toggleOpen"></div>
            </el-col>
            <el-col :span="18">
              <div class="tituloNoticia" :data-testid="TEST_ID.GESTION_NOTICIAS.CARD_TITLE">{{noticia.Titulo}}</div>
            </el-col>
            <el-col :span="4" class="contenedorIconos">
              <div v-if="noticia.EstadoNoticia.Id === 1" class='iconContainer' @click="publicar" v-show="!noticiaPublicada">
                <el-tooltip class="item" effect="dark" :content="$t('NOTICIAS_publicar')" placement="left-start">
                  <el-icon><DocumentChecked /></el-icon>
                </el-tooltip>
              </div>
              <div class='iconContainer' :data-testid="TEST_ID.GESTION_NOTICIAS.CARD_BUTTON_EDIT" @click="editarNoticia">
                <el-tooltip class="item" effect="dark" :content="$t('GENERAL_editBtn')" placement="left-start">
                  <el-icon><Edit /></el-icon>
                </el-tooltip>
              </div>
              <div v-if="noticia.EstadoNoticia.Id !== 3" class='iconContainer' :data-testid="TEST_ID.GESTION_NOTICIAS.CARD_BUTTON_DELETE" v-on:click="anular">
                <el-tooltip class="item" effect="dark" :content="$t('GENERAL_deleteBtn')" placement="left-start">
                  <el-icon><Delete /></el-icon>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>


          <transition name="fade">
            <div class="info" :data-testid="TEST_ID.GESTION_NOTICIAS.CARD_DETAIL" v-show="opened">

              <el-row>
                  <el-col :span="12" class="label greyLabel">ID:</el-col>
                  <el-col :span="12" class="blackLabel" :data-testid="TEST_ID.GESTION_NOTICIAS.CARD_DETAIL_ID">{{noticia.Id}}</el-col>
              </el-row>

              <el-row>
                  <el-col :span="12" class="label greyLabel">{{$t('NOTICIAS_titulo')}}:</el-col>
                  <el-col :span="12" class="blackLabel" :data-testid="TEST_ID.GESTION_NOTICIAS.CARD_DETAIL_TITLE">{{noticia.Titulo}}</el-col>
              </el-row>

              <el-row>
                  <el-col :span="12" class="label greyLabel">{{$t('NOTICIAS_copete')}}:</el-col>
                  <el-col :span="12" class="blackLabel" :data-testid="TEST_ID.GESTION_NOTICIAS.CARD_DETAIL_SUMMARY">{{noticia.Copete}}</el-col>
              </el-row>

              <el-row>
                  <el-col :span="12" class="label greyLabel">{{$t('NOTICIAS_fecha_registro')}}:</el-col>
                  <el-col :span="12" class="blackLabel" :data-testid="TEST_ID.GESTION_NOTICIAS.CARD_DETAIL_REGISTERED_DATE">{{noticia.FechaRegistroStr}}</el-col>
              </el-row>

              <el-row>
                  <el-col :span="12" class="label greyLabel">{{$t('NOTICIAS_registrado_por')}}:</el-col>
                  <el-col :span="12" class="blackLabel" :data-testid="TEST_ID.GESTION_NOTICIAS.CARD_DETAIL_REGISTERED_BY">{{noticia.Usuario.NombreUsuario}}</el-col>
              </el-row>

              <el-row>
                  <el-col :span="12" class="label greyLabel">{{$t('NOTICIAS_fecha_publicacion')}}:</el-col>
                  <el-col :span="12" class="blackLabel" :data-testid="TEST_ID.GESTION_NOTICIAS.CARD_DETAIL_PUBLICATION_DATE">{{noticia.FechaPublicacionStr}}</el-col>
              </el-row>

              <el-row>
                  <el-col :span="12" class="label greyLabel">{{$t('NOTICIAS_estado')}}:</el-col>
                  <el-col :span="12" class="blackLabel" :data-testid="TEST_ID.GESTION_NOTICIAS.CARD_DETAIL_STATUS">{{noticia.EstadoNoticia.Nombre}}</el-col>
              </el-row>


            </div>    
          </transition>
        </div>
      </el-card>
  </div>
</template>

<script>
import TEST_ID from '@/testIds.json'

export default {
  name: "gestionNoticiaCard",
  props: {
    noticia: Object,
    },
  data() {
    return {
      TEST_ID,

      activeNames: ["1"],
      loading: false,
      opened: false,
      noticiaPublicada: false,
    };
  },

  methods: {
    toggleOpen() 
    {
      this.opened = !this.opened      
    },

    editarNoticia() 
    {
      this.$emit('editar', this.noticia.Id)
    },

    publicar() 
    {
      this.$emit('publicar', this.noticia.Id, this.noticia.Titulo)
    },
    noticiaBorrador()
    {
      if(this.noticia.EstadoNoticia.Nombre == "Publicado")
        this.noticiaPublicada = true
    },

    anular() 
    {
      this.$emit('anular', this.noticia.Id, this.noticia.Titulo)
    }
  },
  mounted() 
  {
    this.noticiaBorrador();
  }
}
</script>

<style scoped>


.triangleRight,
.triangleDown {
  width: 0;
  height: 0;
  border-style: solid;
  cursor: pointer;
}
.triangleRight {
  border-width: 8px 0 8px 13.9px;
  border-color: transparent transparent transparent var(--main-color);
}
.triangleDown {
  border-width: 13.9px 8px 0 8px;
  border-color: var(--main-color) transparent transparent transparent;
}
.cardBody {
  width: 100%;
}

.greyLabel {
  color: #6B6B6B;
  font-weight: normal;
}

.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}

.label {
  text-align: left;
  margin-bottom: 4px;
  font-size: 14px;
}

.tituloNoticia{
  font-size: 14px;
  font-weight: bold;
  text-align: left;
}

.btn-nuevo {
  padding-right:0%;
  text-align:right;
}
.el-card {
  height: 100%;
  width: 100% !important;
}


.container {
  display: flex;
  min-height: 500px !important;
  width:  100% !important;
}

.pagination_container {
  text-align: right;
  padding-right:0px;
}

.iconContainer {
  cursor: pointer;
  font-size: 19px;
  margin-left: 4px;
}

.contenedorIconos {
  display: flex;
  justify-content: flex-end;

}

@media (max-width: 600px) {
  .container {
    flex-direction: column;
  }
}

.card_list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 1rem;
}
.card_list_item {
  position: relative;
}
.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
}
.fec_publicacion {
  grid-column-start: 2;
  grid-row-start: 2;
}
.sub-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #999;
}

.info {
  margin-top: 20px;
}



.loader {
  margin-top: 25%;
  color: #999;
}
</style>
